module.exports = __webpack_public_path__ + "img/vertical_6_5_4.47ffd18c.png";